var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileFinishStepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 32,
    viewBox: "0 0 68 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.994229 1.75138C0.30111 1.14266 0.731636 0 1.6541 0H60C65.523 0 68 4.47715 68 10V16V22C68 27.5228 65.523 32 60 32H1.6541C0.731633 32 0.301109 30.8573 0.994228 30.2486L8 16L0.994229 1.75138Z",
    fill: "#39BAFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileFinishStepIcon);
export default __webpack_public_path__ + "static/media/mobile-finish-step-icon.0fa8df506457708aa997a834a551c416.svg";
export { ForwardRef as ReactComponent };